import { render, staticRenderFns } from "./gen-org.vue?vue&type=template&id=107b4316"
import script from "./gen-org.vue?vue&type=script&lang=js"
export * from "./gen-org.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports